var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 28.5C58 12.7599 45.2401 0 29.5 0C13.7599 0 1 12.7599 1 28.5C1 44.2401 13.7599 57 29.5 57C45.2401 57 58 44.2401 58 28.5Z",
    fill: "#00B0CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3262 29.1415L24.5188 35.0978C24.7835 35.4931 25.2228 35.7361 25.6982 35.7503C26.1737 35.7645 26.6267 35.5481 26.9145 35.1694L39.3152 22.5273",
    stroke: "#F2F4F7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.2159a7247106392c3085c7e5688383de.svg";
export { ForwardRef as ReactComponent };